export default __webpack_public_path__ + "static/media/bg-shape-n1.0f5a5e49.png";